import { initializeApp } from "firebase/app";
import { getAnalytics } from "firebase/analytics";
import { getDatabase, connectDatabaseEmulator } from "firebase/database";
import { getAuth, connectAuthEmulator } from "firebase/auth";

// Your web app's Firebase configuration
// For Firebase JS SDK v7.20.0 and later, measurementId is optional
const firebaseConfig = {
  apiKey: process.env.REACT_APP_FIREBASE_API_KEY,
  authDomain: "bawo-19a49.firebaseapp.com",
  databaseURL: "https://bawo-19a49-default-rtdb.europe-west1.firebasedatabase.app",
  projectId: "bawo-19a49",
  storageBucket: "bawo-19a49.appspot.com",
  messagingSenderId: "233535679143",
  appId: "1:233535679143:web:b71387836eceaf70614982",
  measurementId: "G-38J39KW67J"
};

// Initialize Firebase
export const app = initializeApp(firebaseConfig);
export const analytics = getAnalytics(app);
export const database = getDatabase(app);
export const auth = getAuth(app);

// Connect to emulators if in development/test mode
// Use environment variable or hostname to detect E2E test environment
const useEmulators =
  process.env.REACT_APP_USE_FIREBASE_EMULATORS === "true" ||
  (process.env.NODE_ENV === "development" && window.location.hostname === "localhost");

if (useEmulators) {
  try {
    connectAuthEmulator(auth, "http://localhost:9099", { disableWarnings: true });
    connectDatabaseEmulator(database, "localhost", 9000);
    console.log("🔧 Connected to Firebase emulators");
  } catch (error) {
    console.warn("Failed to connect to emulators:", error);
  }
}
